<template>
  <div class="detail-item" v-if="editingData && options">

    <div class="head"><b>雇用形態種別</b></div>
    <div class="data">
      <p>{{ getOptionsLabel(options.keitai_type, editingData.keitai_type) }}</p>
      <p class="current-data" v-if="lastKeitaiTypeLabel">{{ lastKeitaiTypeLabel }}</p>
    </div>
    
  </div>
</template>

<script lang="ts">
import { computed, defineComponent } from 'vue'
import { KoyouKeiyakuOption } from '@/types/KoyouKeiyaku';
import { KoyouKeiyakuDetail } from '@/types/KoyouKeiyakuDetail';
import { useKoyouKeiyakuInit } from '@/composable/koyoukeiyaku/init';

export default defineComponent({
  props: {
    editingData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    currentData: {
      type: Object as () => KoyouKeiyakuDetail | null,
      require: true,
      default: null
    },
    options: {
      type: Object as () => KoyouKeiyakuOption | null,
      require: true,
      default: null
    },
  },
  setup(props) {
    const { getOptionsLabel } = useKoyouKeiyakuInit()

    const lastKeitaiTypeLabel = computed(() => {
      if (!props.options || !props.currentData) {
        return null
      }
      return getOptionsLabel(props.options.keitai_type, props.currentData.keitai_type)
    })

    return {
      getOptionsLabel,
      lastKeitaiTypeLabel
    }
  }
})
</script>

<style lang="scss" scoped>
@import '@scss/components/koyoukeiyaku.scss';
@import '@scss/components/koyoukeiyaku-edit.scss';

</style>
